import { render, staticRenderFns } from "./HorizontalLayout.vue?vue&type=template&id=461309ac&scoped=true"
import script from "./HorizontalLayout.vue?vue&type=script&lang=js"
export * from "./HorizontalLayout.vue?vue&type=script&lang=js"
import style0 from "./HorizontalLayout.vue?vue&type=style&index=0&id=461309ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461309ac",
  null
  
)

export default component.exports